import * as React from "react"
import Autocomplete from "@mui/material/Autocomplete"

import { getRenderInput } from "./getRenderInput"
import { getRenderTags } from "./getRenderTags"
import { AutocompleteChipsProps, AutocompleteItem } from "./types"

export function AutocompleteChips(props: AutocompleteChipsProps) {

  const renderOption = (props, option, _) => (
    <li {...props} key={option.id}>
      {option.title}
    </li>
  )

  const defaultProps = {
    disabled: false,
    // defaultValue: [],
  } as AutocompleteChipsProps;

  const mergedProps = {...defaultProps, ...props}

  const { input, meta } = props.field

  return (
    <Autocomplete
      multiple={true}
      autoComplete
      size="small"
      blurOnSelect
      freeSolo
      clearOnBlur
      selectOnFocus
      forcePopupIcon={false}
      getLimitTagsText={(more) => `+${more}`}
      options={mergedProps.options}
      limitTags={4}
      // classes={props.classes}
      value={(input.value as unknown) as AutocompleteItem[]}
      onChange={(event: any, values: any) => {
        // const values_ = values as AutocompleteItem[]
        // const ids = values_.map(item => item.id)
        input.onChange(values)
      }}
      // onInputChange={() => {}}
      // id={mergedProps.id}
      getOptionLabel={(option: any) => (option.title)}
      // renderOption={renderOption}
      // defaultValue={input.values}
      renderTags={getRenderTags(mergedProps)}
      renderInput={getRenderInput(mergedProps)}
    />
  )
}
